import actionTypes from 'store/actionTypes';
import { initialRolesStateData } from 'store/initialStateData';

export const rolesReducer = (state: any = initialRolesStateData, action) => {
  switch (action.type) {
    case actionTypes.SET_ROLES: {
      return {
        ...state,
        list: action.payload,
        initialLoad: true,
        loading: false,
      };
    }

    case actionTypes.REMOVE_ALL_ROLES: {
      return {
        ...state,
        list: [],
        initialLoad: false,
        loading: true,
      };
    }

    default:
      return state;
  }
};
